import { read, write, clear } from './cookieHelper';

/**
 * Whether the current browser supports local storage as a way of storing data
 * @var {Boolean}
 */
const _hasLocalStorageSupport = (() => {
  try {
    localStorage.setItem('localStorage', 1);
    localStorage.removeItem('localStorage');
    return true;
  } catch (e) {
    return false;
  }
})();

const browserStorage = {
  /**
   * @param {String} name The name of the property to set
   * @param {String} value The value to use when setting the specified property
   * @param {int} [days] The number of days until the storage of this item expires (if storage of the provided item must fallback to using cookies)
   */
  setItem(name, value, days) {
    _hasLocalStorageSupport ? localStorage.setItem(name, value) : write(name, value, days);
  },

  /**
   * @param {String} name The name of the value to retrieve
   * @return {?String} The value of the
   */
  getItem(name) {
    return _hasLocalStorageSupport ? localStorage.getItem(name) : read(name);
  },

  /**
   * @param {String} name The name of the value to delete/remove from storage
   */
  removeItem(name) {
    _hasLocalStorageSupport ? localStorage.removeItem(name) : this.setItem(name, '', -1);
  },

  clear() {
    _hasLocalStorageSupport ? localStorage.clear() : clear();
  },
};

export default browserStorage;
